import React, { memo } from 'react'

import { Cell, FormattedHTMLMessage } from '@web/walter-ui-kit'
import { useUserSetting } from '@web/walter-lib/user-settings'
import { lang } from '../lang'
import { SearchMenuItem } from '../SearchMenuItem'
import styles from './style.module.css'
import { SearchCollectionData } from '~components/PageLayout/types'

interface Props {
    isSearching: boolean
    stopSearching: () => void
    searchData: SearchCollectionData[]
    trendingData: SearchCollectionData[]
    collectionData: SearchCollectionData[]
}

function SearchMenuContent({ isSearching, stopSearching, searchData, trendingData, collectionData }: Props) {
    const [recentlySearched, setRecentlySearched] = useUserSetting('recentlySearched')

    const noResults = !searchData.length && isSearching
    const recentlySearchedData = collectionData.filter(({ code }) => recentlySearched.includes(code))

    const handleSearchedClick = (code: string) => {
        stopSearching()
        if (recentlySearched.includes(code)) {
            return
        }

        if (recentlySearched.length === 5) {
            const filteredSearched = recentlySearched.filter((_, index) => index !== 0)

            setRecentlySearched([...filteredSearched, code])
        } else {
            setRecentlySearched([...recentlySearched, code])
        }
    }

    if (!isSearching) {
        return (
            <div data-pointer="search_wrap">
                {Boolean(recentlySearchedData.length) && (
                    <>
                        <FormattedHTMLMessage className={styles.caption} {...lang.recentlySearched} />
                        {recentlySearchedData.map(item => (
                            <SearchMenuItem
                                item={item}
                                type="searched"
                                onClick={stopSearching}
                                key={`searched_${item.code}`}
                            />
                        ))}
                    </>
                )}

                <FormattedHTMLMessage className={styles.caption} {...lang.trending} />
                {trendingData.map(item => (
                    <SearchMenuItem type="trending" key={`trending_${item.code}`} item={item} onClick={stopSearching} />
                ))}
            </div>
        )
    }

    if (noResults) {
        return (
            <Cell
                padding="l"
                title={<FormattedHTMLMessage tagName="div" className={styles.noResults} {...lang.noResults} />}
            />
        )
    }

    return (
        <div data-pointer="search_wrap">
            {searchData.map(item => (
                <SearchMenuItem key={`search_${item.code}`} item={item} onClick={handleSearchedClick} />
            ))}
        </div>
    )
}

export default memo(SearchMenuContent)
